import './polyfills.js'
import './assets/main.css'
import './assets/ui.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'

const app = createApp(App)
const pinia = createPinia()

pinia.use(({ store }) => {
  store.$onAction(({ name, after, onError }) => {
	if (import.meta.env.DEV) {
	  console.log(`[PINIA] ${store.$id}.${name} start`)
	}

	after(() => {
	  if (import.meta.env.DEV) {
		console.log(`[PINIA] ${store.$id}.${name} done`)
	  }
	})

	onError((e) => {
	  if (import.meta.env.DEV) {
		console.error(`[PINIA] ${store.$id}.${name} error`, e)
	  }
	})
  })
})

app.use(pinia)
app.use(router)
app.mount('#app')
